import React from 'react';
import { connect } from 'react-redux'
import { keys, max, get, sortBy } from 'lodash'
import { Link } from 'react-router-dom'
import TrendChart from '../../components/TrendChart'
import MultiTrendChart from '../../components/MultiTrendChart'
import DistributionChart from '../../components/DistributionChart'
import MapChart from '../../components/MapChart'
import { getLatestFromData } from '../../state/selectors'
import { makeCancelable } from '../../utils'
import Spinner from '../../components/Spinner'
import { Origin } from 'redux-tooltip'

import './index.css'

class DataExplorerTopic extends React.Component {

  state = {
    indicatorData: null,
    loading: true,
    latestDataByIndicator: require("../../data/latest_by_indicator.json")
  }

  componentWillMount = () => {
    const { match } = this.props
    const { topic } = match.params
    const fileName = `/by_indicator/${topic.toLowerCase()}.json`

    this.fetcher = makeCancelable(fetch(fileName))
    this.fetcher
    .promise
    .then(response => {
      return response.json()
      .then(data => {
          this.setState({indicatorData:data, loading:false})
      })
    })
  }

  componentWillUnmount =  () => {
    this.fetcher.cancel()
  }


  render() {

    const { countries, indicators, meta, match } = this.props
    const { topic } = match.params
    const { indicatorData, latestDataByIndicator, loading } = this.state
    //const indicatorData = dataByIndicator[topic]
    const dataMap = getLatestFromData(indicatorData).reduce((acc, val)=>{
      acc[val.country] = val.v
      return acc
    }, {})

    const countriesForIndicator = sortBy(keys(indicatorData), i => countries[i])

    return (
      <div>
        <h2 className="f3 lh-copy text-blue">{indicators[topic].shortTitle || indicators[topic].globalId}</h2>
        <div className="pa1 cf">
          {/* intro text */}
          <p>
            {indicators[topic].fullDescription}
          </p>

          { loading && <Spinner/>}
          { !loading && ( <div>

            {/* previews */}
            <div>
              <div className="w-100 pa3">
                <div className="DataExplorerCountry__Preview border-blue">
                  <MapChart dataMap={dataMap} height={400}
                    topic={topic}
                    interactive={false}
                    showDownloads={true}
                    decreasing={indicators[topic].rankDirection==='1'}
                    emptyFill={"#eee"} minScale={0} className="h-100"/>
                </div>
              </div>
              <div className="w-100 pa3">
                <div className="DataExplorerCountry__Preview border-blue">
                  <DistributionChart indicator={topic} height={50} distributionData={latestDataByIndicator[topic]} style={{width:'100%'}}/>
                </div>
              </div>
              <div className="w-100 pa3">
                <div className="DataExplorerCountry__Preview border-blue">
                  <MultiTrendChart indicatorData={indicators[topic]}
                    height={100} dataByIndicator={indicatorData} style={{width:'100%'}}/>
                </div>
              </div>
            </div>

            {/* dropdown and download */}
            {/* <div>
              Dropdown here - Download here
            </div> */}


            {/* data table */}
            {/* data table header */}
            <div className="cf">
              <div className="fl w-third">
                <h3 className="f3 lh-copy DataExplorer__table_heading">COUNTRY</h3>
              </div>
              <div className="fl w-third">
                <h3 className="f3 lh-copy DataExplorer__table_heading">TREND</h3>
              </div>
              <div className="fl w-third">
                <h3 className="f3 lh-copy DataExplorer__table_heading">SCORE</h3>
              </div>
            </div>

            { countriesForIndicator.map(country => {

              //latest value
              const lastYear = max(keys(indicatorData[country]))
              if(!lastYear){ return null }
              const value = indicatorData[country][lastYear]['v']
              const m = indicatorData[country][lastYear]['m']

              return (
              <div className="cf pv3 bb border-blue" key={country}>
                <div className="fl w-third">
                  <div className="DataExplorer__Block">
                    <Link className="no-underline underline-hover text-blue" to={`/countries/${country}`} >{ countries[country] }</Link>
                  </div>
                </div>
                <div className="fl w-third">
                  <div className="ph0">
                    <TrendChart
                      indicatorData={indicators[topic]} showScores={false}
                      countryCode={country} dataByCountry={indicatorData[country]}/>
                  </div>
                </div>
                <div className="fl w-third">
                  <div className="DataExplorer__Block cf">
                    <div className="w-100">
                      <div className="fl w-25 tl"><span className="DataExplorer__Value">{value}</span></div>
                      <div className="fl w-75 tr"><Origin content={<div style={{maxWidth:'300'}}>{get(meta, m, "" ).replace(/\|/g,' | ').split(";").map(piece=><div key={piece}>{piece}</div>)}</div>}>MORE INFO</Origin></div>
                    </div>
                  </div>
                </div>
              </div>
              )
            })}


          </div>)}

        </div>

      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  countries: state.countries,
  indicators:  state.indicators,
  meta:  state.meta,
  dataByIndicator: state.dataByIndicator,
})

export default connect(mapStateToProps)(DataExplorerTopic)



// WEBPACK FOOTER //
// ./src/pages/DataExplorerTopic/index.js